import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppSettingsService } from '@capital-access/common/settings';
import { AppModule } from './app/app.module';

AppSettingsService.load().then(() => {
  return platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
